import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';
import { useUpdateTotalNotification } from '../../utils/useUpdateTotalNotification';

// PACKAGES
import { useHistory } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../components/GlobalModal';
import { FeedbackWithdrawCommand } from '../../api/models';

interface WithdrawModalTypes {
	feedbackId?: string;
	closeModal?: closeModalType;
	subject?: string;
}

const WithdrawModal: React.FC<WithdrawModalTypes> = ({ feedbackId, closeModal, subject }) => {
	const history = useHistory();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const withdrawFeedback = async () => {
		if (feedbackId !== undefined) {
			setIsLoading(true);

			const data: FeedbackWithdrawCommand = { id: feedbackId };

			const response = await apibridge.withdrawFeedback(data);

			if (response.isError) {
				setIsLoading(false);

				setFormErrorMessage(
					response.validationErrors.length
						? validationErrorsToString(response.validationErrors)
						: response.message || 'An error has occurred'
				);
			} else {
				setIsLoading(false);

				history.push('/feedback');

				useUpdateTotalNotification();
			}
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to withdraw <strong>'{subject}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={withdrawFeedback}>
										Yes
									</Button>

									<Button
										className="btn-secondary full-width"
										onClick={() => {
											if (closeModal) {
												closeModal();
											}
										}}
									>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default WithdrawModal;
